/* src/app/components/fileTriage/file-triage-list/file-triage-list.component.css */
.table-style {
  width: 100%;
}
#fileTriagePreviewHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#fileTriagePreview .actions-container {
  padding-bottom: 1rem;
  display: flex;
}
#fileTriagePreview .actions-container div {
  margin-right: 0;
  margin-left: auto;
  display: flex;
}
::ng-deep .file-triage--drawer .ant-drawer-header .ant-drawer-close:focus-visible {
  outline: 3px solid black;
  outline-offset: 3px;
}
/*# sourceMappingURL=file-triage-list.component-D26AMXOV.css.map */
